import { render, staticRenderFns } from "./certificateDialog.vue?vue&type=template&id=88f6de20&scoped=true"
import script from "./certificateDialog.vue?vue&type=script&lang=js"
export * from "./certificateDialog.vue?vue&type=script&lang=js"
import style0 from "./certificateDialog.vue?vue&type=style&index=0&id=88f6de20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f6de20",
  null
  
)

export default component.exports